import { SVGProps } from "react";

const TickThin = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={43}
    height={43}
    viewBox="0 0 43 43"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8 21.5L16.9894 30.5L35 12.5"
      stroke="currentColor"
      strokeWidth={1.4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default TickThin;
